// src/pages/NFTPage.js
import React from "react";
import NFTAuth from "./NFTAuth";

const NFTPage = (props) => {
  return (
    <div>
      <NFTAuth setownerId={props.setownerId} />
    </div>
  );
};

export default NFTPage;
